import { Reducer } from 'react';
import { DRM } from './types';

export function getKeySystemWithUrl(drm: DRM, url?: string, cerficateUrl?: string) {
  return {
    drm: {
      servers: {
        [drm]: url,
      },
      ...(cerficateUrl
        ? {
            advanced: {
              [drm]: {
                serverCertificateUri: cerficateUrl,
              },
            },
          }
        : {}),
    },
  };
}

export function getKeySystemClearKey(key = '', keyId: string) {
  return {
    drm: {
      clearKeys: {
        [keyId]: key,
      },
    },
  };
}

export enum PlayerState {
  Created,
  Ready,
  SourceLoaded,
  Error,
}

export enum PlayerAction {
  Ready,
  Loaded,
  Error,
  ShowControls,
  HideControls,
}

export type VideoState = { playerState: PlayerState; controlsVisible: boolean; errorCode?: shaka.util.Error.Code };
export type VideoActionType = {
  type: PlayerAction;
  payload?: shaka.util.Error.Code;
};

export const videoReducer: Reducer<VideoState, VideoActionType> = (state, { type, payload }) => {
  switch (type) {
    case PlayerAction.Ready:
      return { ...state, playerState: PlayerState.Ready };
    case PlayerAction.Loaded:
      return { ...state, playerState: PlayerState.SourceLoaded, errorCode: undefined };
    case PlayerAction.Error:
      return { ...state, playerState: PlayerState.Error, errorCode: payload, controlsVisible: false };
    case PlayerAction.ShowControls:
      return { ...state, controlsVisible: true };
    case PlayerAction.HideControls:
      return { ...state, controlsVisible: false };
    default:
      return state;
  }
};
